import { render, staticRenderFns } from "./ShiftAtomSouffling.vue?vue&type=template&id=203cea2d&"
import script from "./ShiftAtomSouffling.vue?vue&type=script&lang=ts&"
export * from "./ShiftAtomSouffling.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftAtomSouffling.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports